import { render, staticRenderFns } from "./DocumentMang.vue?vue&type=template&id=28328b41&scoped=true"
import script from "./DocumentMang.vue?vue&type=script&lang=js"
export * from "./DocumentMang.vue?vue&type=script&lang=js"
import style0 from "./DocumentMang.vue?vue&type=style&index=0&id=28328b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28328b41",
  null
  
)

export default component.exports